module.exports = __webpack_public_path__ + "img/default_male_picture.98702ec5.png";